<template>
  <v-app>
    <Toolbar />

    <v-main>
      <Drawer v-if="this.$store.getters.isLoggedIn === true"/>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-main>
  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar'
import Drawer from './components/Drawer'
export default {
  name: 'App',

  components: {
    Toolbar,
    Drawer
  }
};
</script>
